import type {
	DomainDetail,
	MemberRadarResponse,
	OrgProgress,
} from "@/types/api";
import { http } from "./http";

/**
 * Learning progress: where the organisation, and each person in it, is actually
 * learning.
 *
 * This is ACTIVITY, not mastery. The radar counts what someone engaged with and
 * how far they got through it, per domain, across every format — reading,
 * listening, watching and whiteboard lessons. Nothing here claims they know it.
 *
 * Each read is audited server-side as `member.viewed`, exactly like the People
 * screen, so an employee asking who looked at their learning has an answer.
 */
export const progressService = {
	/** The company radar and a row per seat. */
	org: (signal?: AbortSignal) =>
		http.get<OrgProgress>("/api/org/progress", { signal }),

	/** One seat's radar, as that learner sees it. */
	member: (memberId: string, signal?: AbortSignal) =>
		http.get<MemberRadarResponse>(`/api/org/progress/${memberId}`, { signal }),

	/** The concepts and pieces behind one axis. */
	domain: (memberId: string, domain: string, signal?: AbortSignal) =>
		http.get<DomainDetail>(
			`/api/org/progress/${memberId}/domains/${encodeURIComponent(domain)}`,
			{ signal },
		),
};
